module.exports = __webpack_public_path__ + "media/images/medal_3-f10ddd01343aad2b84ed3ae2d5150f06.svg";